export default "__VITE_ASSET__ByAIsaEh__"